export interface AttachmentItem {
  id: string;
  type?: string;
  document_type?: string;
  url?: string;
  file?: string;
  file_url?: string;
  file_name?: string;
  size_mb?: number;
  created_at?: string;
}

/**
 * Convert flat attachment array to legacy dictionary format { type: url | url[] }.
 * Handles both old dict format (passthrough) and new array format (transform).
 * Supports multiple field name variations from the API (type/document_type, url/file/file_url).
 */
export function normalizeAttachments(
  documents: AttachmentItem[] | Record<string, any> | undefined | null
): Record<string, any> {
  if (!documents || !Array.isArray(documents)) {
    return documents || {};
  }

  const result: Record<string, any> = Object.create(null);
  for (const doc of documents) {
    if (!doc || typeof doc !== 'object') continue;
    const docType = doc.type || doc.document_type;
    const docUrl = doc.url || doc.file || doc.file_url;

    if (!docType || !docUrl) continue;

    if (result[docType]) {
      if (Array.isArray(result[docType])) {
        result[docType].push(docUrl);
      } else {
        result[docType] = [result[docType], docUrl];
      }
    } else {
      result[docType] = docUrl;
    }
  }
  return result;
}
